const namespace = 'legal-compliance-requests';

export const GET_LEGAL_COMPLIANCE_REQUEST_BY_TOKEN = `${namespace}/By Token Get`;
export const GET_LEGAL_COMPLIANCE_REQUEST_BY_TOKEN_SUCCESS = `${namespace}/By Token Get Success`;
export const GET_LEGAL_COMPLIANCE_REQUEST_BY_TOKEN_FAIL = `${namespace}/By Token Get Fail`;
